// Which documents the User manuals panel shows, in which group and in which order.
//
// Each entry carries one Google Drive id per language, because a translation is its own
// document in Drive with its own id. Ids never change, so a document can be renamed or
// moved in Drive without breaking the menu. An id that is not in the synced index is
// skipped silently, so an entry can be listed here before the document reaches storage -
// it appears on its own row once the sync picks it up.
//
// A language that has no id for an entry falls back to MANUALS_FALLBACK_LANGUAGE, so a
// half finished translation shows the English document rather than nothing. Labels fall
// back the same way.
//
// The Drive folder is a working area holding archives, drafts and translation originals,
// so this list is deliberately curated rather than generated: nothing reaches a customer
// until it is named here.
//
// TODO: labels are hardcoded rather than translation keys. The German ones are shortened
// from the German document titles in Drive, so the wording is the documentation team's own.
// Product names and "Read Me First" are left as they are, since the German documents
// spell them the same way.
export const MANUAL_GROUPS = [
  {
    label: "Camur",
    collection: "usermanuals",
    documents: [
      {
        key: "readme-first",
        labels: { en: "ReadMe First", de: "Read Me First" },
        ids: {
          en: "1e8_ZoBCYqFMiXMRMSi_A9UY8Fv5XsjldMev7daJMNtQ",
          de: "1ZVpBotXsG16HuogHIOoM43G3RkJOzPlJBBAcerI7r4Q"
        }
      },
      {
        key: "basic-overview",
        labels: { en: "Basic overview", de: "Grundlegender Überblick" },
        ids: {
          en: "1PWl8rSqr_ss-MDSE1GVI4uDnkLyy2JdNqGi2Mah38YY",
          de: "1jZ99ZYTowlt5GoaZ4zql9VkWM-K0YPTuvxGWzBO8zNc"
        }
      },
      {
        key: "designing",
        labels: { en: "Designing", de: "Designen einer Installation" },
        ids: {
          en: "1l16Api70dqcYacYYhLso8HsyEeBYTB5iSwE_N_40SBM",
          de: "1qCScm7rDCKWtX71MO-YfYEW3SaPxe6piQEYWlgW_N4U"
        }
      },
      {
        key: "workspace-quick-start",
        labels: { en: "Workspace Quick Start", de: "Kurzanleitung Workspace" },
        ids: {
          en: "1-clRYsFrFgO5RV7HAtcEzhT9UFQdiCohI3CRazlyGTo",
          de: "1v9lVC6Pp1ptZrU3z5xIx3uLJs2164IXu1NUZIgjZVak"
        }
      },
      {
        key: "fixvolt-3-and-8",
        labels: { en: "FixVolt 3 & 8", de: "FixVolt 3 & 8" },
        ids: {
          en: "1F0IP84K8JPhtDeqG7XqXfV6US1UhuPrFKaX5g99_sG0",
          de: "1O_MjNY5KszL7lSKEsxjpxqNJ-fyGXhJN-euCJ-NqM14"
        }
      },
      {
        key: "p-p4-and-pt",
        labels: { en: "P, P4 and P+t", de: "P, P4 und P+t" },
        ids: {
          en: "18EkYzbbsfAV_Zg0awp19Tc6ZdUm2pEpjq7gQ_MGzGHQ",
          de: "1OYYUDKcXIWIiWTnPxsFxB7JnNrQBBquTIkpUB2IwpfM"
        }
      },
      {
        key: "zra",
        labels: { en: "ZRA", de: "ZRA" },
        ids: {
          en: "1AsWGtX66mLj9YiMLUAVGCt3jVQ3X6LRM2Wo04iV0LQg",
          de: "1_5AIbn6FaJTf5gkqMfI2tFYIXHPjOCNGjD3OmnlzfX0"
        }
      },
      {
        key: "workspace-user-manual",
        labels: { en: "Workspace User Manual", de: "Benutzerhandbuch Workspace" },
        ids: {
          en: "1T-2PG8GbyXovhT9oCOMd3YbRfi1NQIWrd_eLHiNhBqM",
          de: "1MHFUYj5iYFSU6JD74_d_39IhCXep1srsXIxteJwX45o"
        }
      }
    ]
  }
];

export const MANUALS_FALLBACK_LANGUAGE = "en";

// The blob container holds one collection per documentation folder in Drive, so paths
// read collection/language/file.
export const MANUALS_COLLECTION = "usermanuals";
export const DATASHEETS_COLLECTION = "datasheets";
